// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productImageCarouselStyles } from "@guestsupply/Overrides/Components/ProductImageCarousel";
import { color, xScreen } from "@guestsupply/XDL/Utilities";
import { css } from "styled-components";

const imageCss = css`
    width: 100%;
    height: 100%;
    max-width: 92px;
    max-height: 92px;
    cursor: pointer;
    border-radius: 4px;
    img {
        max-width: 92px;
        max-height: 92px;
    }
    ${xScreen("lte", "md")} {
        max-width: 62px;
        max-height: 62px;
        img {
            max-width: 62px;
            max-height: 62px;
        }
    }
`;

productImageCarouselStyles.img = {
    css: css`
        ${imageCss}
        opacity: 0.33;
    `,
};
productImageCarouselStyles.imageSelected = {
    css: css`
        ${imageCss}
        border: 1px solid ${color("common.ui9")};
    `,
};

productImageCarouselStyles.imagesContainer = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        gap: 22px;
        ${xScreen("lte", "md")} {
            gap: 12px;
        }
    `,
};
